// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".per-page-selector[data-v-52543866]{width:90px}.invoice-filter-select[data-v-52543866]{min-width:190px}.invoice-filter-select[data-v-52543866]  .vs__selected-options{flex-wrap:nowrap}.invoice-filter-select[data-v-52543866]  .vs__selected{width:100px}", ""]);
// Exports
module.exports = exports;
